module.exports = __webpack_public_path__ + "img/icon-component-label_BookInformation.60bda5ee.svg";